// extracted by mini-css-extract-plugin
export default {"modal":"BU-z","overlay":"CU-z","outfitSelector":"DU-z","outfitHeading":"EU-z","itemContainer":"FU-z","item":"GU-z","selected":"HU-z"};